import { type SyntheticEvent, useState } from 'react'
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import CircularProgress from "@mui/material/CircularProgress"
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded"
import { Appliance } from '../types'
import UpdateApplianceForm from '../components/forms/appliance/update'
import DeleteApplianceForm from '../components/forms/appliance/delete'
// import ApplianceControlList from '../components/lists/appliance-control'
// import ApplianceControlWebsocketList from './lists/appliance-control-websocket'
import { useBasicConsumption } from "../hooks/use-basic-consumption"
import SocketWizard from './socket-wizard'
import CustomButton from './custom-button'

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

interface TabPanelProps {
    children?: React.ReactNode
    dir?: string
    index: number
    value: number
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ pt: 3 }}>
            {children}
          </Box>
        )}
      </div>
    )
}

function ApplianceSettingsTabs({
    appliance,
    resetDrawer,
}: {
    appliance: Appliance,
    resetDrawer: Function,
}) {

    const [value, setValue] = useState(0)

    const handleChange = (_event: SyntheticEvent, newValue: number) => {
        setValue(newValue)
    }

    const [success, setSuccess] = useState<boolean>(false)

    const { status, data, error } = useBasicConsumption(appliance.id)

    if (status === 'pending') {
        return (
            <CircularProgress />
        )
    }

    if (error) {
        return (
            <Box>
                <ErrorOutlineRoundedIcon />
                <Box>{error.message}</Box>
            </Box>
        )
    }

    return (
        <Box sx={{ width: '100%', minHeight: '680px' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="appliance settings tabs"  variant='fullWidth'>
                    <Tab label="Bojler" {...a11yProps(0)} sx={{ textTransform: 'none', fontSize: '1rem' }} />
                    <Tab label="Zásuvka" {...a11yProps(1)} sx={{ textTransform: 'none', fontSize: '1rem' }} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <Box sx={{
                    fontSize: '1.25rem',
                    flexGrow: 1,
                    color: 'primary.main',
                    display: 'flex',
                    alignItems: 'center',
                    paddingBottom: 2,
                }}>
                    {'Nastavení Bojler '+appliance.id}
                </Box>
                <UpdateApplianceForm appliance={appliance} basicConsumption={data} resetDrawer={resetDrawer}/>
                <DeleteApplianceForm applianceId={appliance.id} estateId={appliance.estate_id}/>
                <Box pb={2}/>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <Box sx={{
                    py: 2,
                }}>
                    <SocketWizard
                        applianceId={appliance.id}
                        successCallback={setSuccess}
                        showHdoDependencyToggle
                    />
                </Box>
                {success &&
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                        <CustomButton
                            color="primary"
                            text="Hotovo"
                            onClick={() => resetDrawer()}
                        />
                    </Box>
                }
            </TabPanel>
        </Box>
    )
}

export default ApplianceSettingsTabs
